import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@lionstep/ui';
import { Doughnut } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

// Components
import NoDataLabel from './NoDataLabel';

// Styles
import styles from './charts.module.scss';

const ValidatedByChannelChart = ({ insights, formatterFunc }) => {
  const { t } = useTranslation();

  const config = formatterFunc({
    activeSourcing: insights.validated_extension,
    multiChanel: insights.validated_non_extension,
    styles,
    t,
  });

  const noData =
    !insights.validated_extension && !insights.validated_non_extension;

  return (
    <>
      <Heading level={4} className={styles.doughnutTitle}>
        {t('insights_page.validation_by_channel.title')}
        {noData && <NoDataLabel />}
      </Heading>
      <div className={styles.doughnutContainer}>
        <div className={styles.doughnutContainerChart}>
          <Doughnut {...config} />
        </div>
        <div
          id="validationByChannelLegend"
          className={styles.doughnutContainerLegend}
        />
      </div>
    </>
  );
};

ValidatedByChannelChart.propTypes = {
  formatterFunc: PropTypes.func.isRequired,
  insights: PropTypes.shape().isRequired,
};

export default ValidatedByChannelChart;
